import anime from '@/assets/libs/anime';
import { inApp } from '@/scripts/utils';
import { paragraphInit, paragraphAnim, paragraphOut } from '../timelines/paragraph';
import { appButtonInit, appButtonAnim, appButtonOut } from '../timelines/appButton';
import { gridHideInit, gridHideAnim, gridHideOut } from '../timelines/gridHide';

export function introEnter(el, delay = 0) {
  const ctx = el;
  const text = ctx.querySelector('.intro__content p');
  const button = ctx.querySelector('.app__button');
  const gridHide = ctx.querySelector('.grid-hide');
  ctx.style.opacity = 0;

  ctx.style.opacity = 1;
  if (!inApp()) {
    paragraphInit(text);
    gridHideInit(gridHide);
    gridHideAnim(gridHide, delay);
    paragraphAnim(text, delay + 100);
  } else {
    anime({
      targets: '.intro__bg',
      scale: [1.5, 1],
      opacity: [0, 0.75],
      easing: 'cubicBezier(.5,0,0,1)',
      duration: 1200,
    });
  }
  appButtonInit(button);
  appButtonAnim(button, delay + 1200);
}

export function introLeave(el, delay = 0) {
  const ctx = el;
  const text = ctx.querySelector('.intro__content p');
  const button = ctx.querySelector('.app__button');
  const gridHide = ctx.querySelector('.grid-hide');
  let finalTween;

  appButtonOut(button, delay + 500);

  if (!inApp()) {
    paragraphOut(text, delay);
    finalTween = gridHideOut(gridHide, delay + 1500);
  } else {
    finalTween = anime({
      targets: '.intro__bg',
      scale: [1, 1.5],
      opacity: [0.75, 0],
      easing: 'cubicBezier(.5,0,0,1)',
      duration: 1200,
      delay: delay + 750,
    });
  }

  return finalTween;
}
